import { Image, Type, Upload } from "lucide-react";
import styles from "./FooterBrand.module.css";

const FooterBrand = ({
  brandName,
  setBrandName,
  brandDescription,
  setBrandDescription,
  brandLogoUrl,
  setBrandLogoUrl,
  onUploadLogo,
  uploadLoading = false,
  uploadError = null,
}) => {
  const handleFileChange = async (event) => {
    const file = event.target.files?.[0];
    if (!file || !onUploadLogo) return;
    await onUploadLogo(file);
    event.target.value = "";
  };

  return (
    <div className={styles.card}>
      <div className={styles.cardHeader}>
        <div className={styles.headerLeft}>
          <div className={styles.iconBox}>
            <Type size={16} />
          </div>
          <div>
            <h3>Footer Brand</h3>
            <p>Brand block shown on the left side of the footer</p>
          </div>
        </div>
      </div>

      <div className={styles.grid}>
        <div className={styles.field}>
          <label>Brand Name</label>
          <input
            className={styles.input}
            value={brandName}
            onChange={(e) => setBrandName(e.target.value)}
            placeholder="e.g. Sunsky"
          />
        </div>
        <div className={styles.field}>
          <label>Brand Logo URL</label>
          <div className={styles.logoRow}>
            <div className={styles.logoInputWrap}>
              <Image size={15} />
              <input
                className={styles.input}
                value={brandLogoUrl}
                onChange={(e) => setBrandLogoUrl(e.target.value)}
                placeholder="e.g. /assets/logo.png"
              />
            </div>
            <label className={styles.uploadBtn}>
              <Upload size={14} />
              {uploadLoading ? "Uploading..." : "Footer Logo"}
              <input
                type="file"
                accept=".png,.jpg,.jpeg,.svg,.webp"
                onChange={handleFileChange}
                disabled={uploadLoading}
                className={styles.fileInput}
              />
            </label>
          </div>
          {uploadError ? <p className={styles.uploadError}>{uploadError}</p> : null}
          {brandLogoUrl ? (
            <div className={styles.previewWrap}>
              <img src={brandLogoUrl} alt="Footer brand logo preview" className={styles.logoPreview} />
            </div>
          ) : null}
        </div>
      </div>

      <div className={styles.field}>
        <label>Brand Description</label>
        <textarea
          className={styles.textarea}
          value={brandDescription}
          onChange={(e) => setBrandDescription(e.target.value)}
          placeholder="e.g. Your gateway to the world's most beautiful destinations..."
        />
      </div>
    </div>
  );
};

export default FooterBrand;
